import { gql } from 'graphql-request'

export const AddWelcomeMessageGql = gql`
  mutation addWelcomeMessage($message: String!) {
    addWelcomeMessage(message: $message) {
      errorMessage
      success
    }
  }
`
